import { Currency } from "@/@types/shared/currancy";
import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";

interface CurrencyState {
  currencies: Currency[];
  defaultCurrency: string;
  currentCurrency: string;
}
interface CartActions {
  setCurrencies(currencies: Currency[]): void;
  addCurrency(currencie: Currency): void;
  setCurrentCurrency(currencyId: string): void;
  clearCurrencies(): void;
}

const state = (): CurrencyState => ({
  currencies: [],
  defaultCurrency: "",
  currentCurrency: "",
});

const getters: _GettersTree<CurrencyState> = {
  // Получить валюту по умолчанию
  defaultCurrencyObject: (state): Currency | undefined => {
    return state.currencies.find((currency) => currency._id === state.defaultCurrency);
  },
  // Получить текущую валюту
  currentCurrencyObject: (state): Currency | undefined => {
    return state.currencies.find((currency) => currency._id === state.currentCurrency);
  },
  // Получить валюту по ID
  getCurrencyById:
    (state) =>
    (id: string): Currency | undefined => {
      return state.currencies.find((currency) => currency._id === id);
    },
  // Получить валюту по коду
  getCurrencyByCode:
    (state) =>
    (code: number): Currency | undefined => {
      return state.currencies.find((currency) => currency.code === code);
    },
  // Получить количество валют
  currenciesCount: (state): number => {
    return state.currencies.length;
  },
};

const actions = {
  // Запись валют в хранилище
  setCurrencies(this: CartActions & CurrencyState, currencies: Currency[]) {
    this.currencies = currencies;

    // Автоматически находим валюту по умолчанию
    const defaultCurrency = currencies.find((currency) => currency.isDefault);
    if (defaultCurrency) {
      this.defaultCurrency = defaultCurrency._id;
      if (!this.currentCurrency) this.currentCurrency = defaultCurrency._id;
    }
  },
  // Добавление одной валюты
  addCurrency(this: CartActions & CurrencyState, currency: Currency) {
    this.currencies.push(currency);
    if (currency.isDefault) this.defaultCurrency = currency._id;
  },
  // Установка текущей валюты
  setCurrentCurrency(this: CartActions & CurrencyState, currencyId: string) {
    this.currentCurrency = currencyId;
  },
  // Установка валюты по умолчанию
  setDefaultCurrency(this: CartActions & CurrencyState, currencyId: string) {
    this.defaultCurrency = currencyId;
  },
  // Очистка хранилища
  clearCurrencies(this: CartActions & CurrencyState) {
    this.currencies = [];
    this.defaultCurrency = "";
    this.currentCurrency = "";
  },
};

export const useCurrencyStore: StoreDefinition<
  "currency",
  CurrencyState,
  _GettersTree<CurrencyState>,
  _ActionsTree
> = defineStore("currency", {
  state,
  getters,
  actions,
});
